import React, { Component, Fragment } from 'react';
import { Link, NavLink } from 'react-router-dom'
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import 'react-bootstrap'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import sweetAlert from 'sweetalert' 


export class Datatable_user extends Component {
    constructor(props) {
        super(props)
        this.state = {
            checkedValues: [],
            myData: this.props.myData,
        }
        this.disableIt = this.disableIt.bind(this)
    }

    disableIt = (id) => {
        const url = `${process.env['REACT_APP_HOST']}/api/users/${id}`;
        const params = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                disable: 1,
            }),
        };
        fetch(url, params)
            .then(response => response.json())
            .then(data => {
                toast.success("User Disabled Successfully!")
                window.location.reload()
            })
    }

    enableIt = (id) => {
        const url = `${process.env['REACT_APP_HOST']}/api/users/${id}`;
        const params = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                disable: 0,
            }),
        };
        fetch(url, params)
            .then(response => response.json())
            .then(data => {
                toast.success("User Enabled Successfully!")
                window.location.reload()
            })
    }

    selectRow = (e, i) => {
        if (!e.target.checked) {
            this.setState({
                checkedValues: this.props.checkedValues.filter((item, j) => i !== item)
            });
        } else {
            this.props.checkedValues.push(i);
            this.setState({
                checkedValues: this.props.checkedValues
            })
        }
    }

    handleRemoveRow = () => {
        const selectedValues = this.props.checkedValues;
        const updatedData = this.props.myData.filter(function (el) {
            return selectedValues.indexOf(el.id) < 0;
        });
        this.setState({
            myData: updatedData
        })
        toast.success("Successfully Deleted !")
    };

    renderEditable = (cellInfo) => {
        return (
            <div
                style={{ backgroundColor: "#fafafa" }}
                contentEditable
                suppressContentEditableWarning
                onBlur={e => {
                    const data = [...this.props.myData];
                    data[cellInfo.index][cellInfo.column.id] = e.target.innerHTML;
                    this.setState({ myData: data });
                }}
                dangerouslySetInnerHTML={{
                    // __html: this.props.myData[cellInfo.index][cellInfo.column.id]
                    __html: [cellInfo.original.id][0]
                }}
            />
        );
    }

    Capitalize(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    deleteHandler = (id) => {
        const url = `${process.env['REACT_APP_HOST']}/api/users/${id}`;
        const params = {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            }
        };
        fetch(url, params)
            .then(response => response.json())
            .then(data => {
            })
    }

    render() {
        const { pageSize, myClass, multiSelectOption, pagination } = this.props;
        const { myData } = this.props;
        const columns = [];
        for (var key in myData[0]) {

            let editable = this.renderEditable

            if (key === "id") {
                editable = null;
            }
            if (key === "firstName") {
                editable = null;
            }
            if (key === "lastName") {
                editable = null;
            }
            if (key === "email") {
                editable = null;
            }
            // if (key === "isAdmin") {
            //     editable = null;
            // }

            console.log(key);

            if (!['id', 'disable', 'isAdmin'].includes(key)) {
                columns.push(
                    {
                        Header: <b>{this.Capitalize(key.toString())}</b>,
                        accessor: key,
                        Cell: editable,
                        style: {
                            textAlign: 'center'
                        }
                    });
                                     }
            
        }

        if (multiSelectOption == true) {
            columns.push(
                {
                    Header: <button className="btn btn-danger btn-sm btn-delete mb-0 b-r-4"
                        onClick={
                            (e) => {
                                if (window.confirm('Are you sure you wish to delete this item?'))
                                    this.handleRemoveRow()
                            }}>Delete</button>,
                    id: 'delete',
                    accessor: str => "delete",
                    sortable: false,
                    style: {
                        textAlign: 'center'
                    },
                    Cell: (row) => (
                        <div>
                            <span >
                                <input type="checkbox" name={row.original.id} defaultChecked={this.props.checkedValues.includes(row.original.id)}
                                    onChange={e => this.selectRow(e, row.original.id)} />
                            </span>
                        </div>
                    ),
                    accessor: key,
                    style: {
                        textAlign: 'center'
                    }
                }
            )
        } else {
            columns.push({
                Header: <b>Action</b>,
                id: 'delete',
                accessor: str => "delete",
                Cell: (row) => (

                    row.original.isAdmin == true ? <div style={{ width: 35, fontSize: 20, padding: 11}}></div> :
                        <div >
                            <span onClick={() => {
                                // if (window.confirm('Are you sure you wish to delete this item?')) {
                                //     let data = myData;
                                //     data.splice(row.index, 1);
                                //     this.setState({ myData: data });
                                //     this.deleteHandler(row.original.id);
                                //     toast.success("Successfully Deleted !")
                                // }

                                sweetAlert({ title: "Are1 you sure you wish to delete this user?", icon: "warning", dangerMode: true, buttons: true })
                                    .then((value) => {
                                        if (value) {
                                            let data = myData;
                                            data.splice(row.index, 1);
                                            this.setState({ myData: data });
                                            this.deleteHandler(row.original.id);
                                            toast.success("Successfully Deleted !")
                                        }
                                    })

                            }}>
                                <i className="fa fa-trash" style={{ width: 35, fontSize: 20, padding: 11, color: '#e4566e' }}
                                ></i>
                            </span>

                            {(() => {
                                if (row.original.disable == 0) {
                                    return (
                                        <span onClick={() => { this.disableIt(row.original.id) }}><i className="fa fa-unlock" style={{ width: 35, fontSize: 20, padding: 11, color: 'rgb(40, 167, 69)' }}></i></span>

                                    );
                                } else {
                                    return (
                                        <span onClick={() => { this.enableIt(row.original.id) }}><i className="fa fa-lock" style={{ width: 35, fontSize: 20, padding: 11, color: 'rgb(40, 167, 69)' }}></i></span>

                                    );
                                }
                            })()
                            }

                        </div>

                ),
                style: {
                    textAlign: 'center'
                },
                sortable: false
            })
        }

        columns.push({
            Header: <b>Report</b>,
            id: 'Report',
            accessor: str => "Report",
            // accessor: str => <button className="btn btn-md btn-success">Report</button>,
            // accessor: str => row.original.isAdmin==true ? <div style={{ width: 35, fontSize: 20, padding: 11}}></div> : <button type="button" class="btn btn-dark">Report</button>,
            Cell: (row) => (

                row.original.isAdmin == true ? <div style={{ width: 35, fontSize: 20, padding: 11}}></div> 
                :
                <>
                   <Link to={`/openreport/${row.original.id}`} className="btn btn-success">Report</Link>
                </>

            ),
                style: {
                    textAlign: 'center'
                }
        })

        return (
            <Fragment>
                <ReactTable
                    data={myData}
                    columns={columns}
                    defaultPageSize={pageSize}
                    className={myClass}
                    showPagination={pagination}
                />
                <ToastContainer />
            </Fragment>
        )
    }
}

export default Datatable_user
